import React, { useContext } from 'react';
import { Button, Input, Table, Tag } from 'antd';
import {
    SearchOutlined,
    TagOutlined,
} from '@ant-design/icons';

import useVouchers from './useVouchers';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function Vouchers() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        columns,
        tableData,
        pagination,
        activeFilterItems,
        quickCodeInput,
        setQuickCodeInput,
        handleQuickCodeSubmit,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        navigate,
    } = useVouchers();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<TagOutlined />}
                title="Vouchers"
                tag={<Tag color="blue">{poeValorComPontosEmMil(tableData.length)} resgates</Tag>}
                subtitle="Acompanhe e gerencie os resgates de recompensas, valide códigos e confirme as entregas aos cidadãos"
                actions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Input
                            placeholder="Código do Voucher (6 dígitos)"
                            value={quickCodeInput}
                            onChange={(e) => setQuickCodeInput(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            onPressEnter={() => handleQuickCodeSubmit()}
                            maxLength={6}
                            style={{
                                width: 220,
                                height: 38,
                                borderRadius: 8,
                                fontFamily: 'monospace',
                                fontWeight: 600,
                                letterSpacing: 1,
                            }}
                            prefix={<TagOutlined style={{ color: isDark ? '#64748b' : '#94a3b8' }} />}
                            allowClear
                        />
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => handleQuickCodeSubmit()}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6,
                                fontWeight: 600,
                                height: 38,
                                borderRadius: 8,
                            }}
                        >
                            Consultar Código
                        </Button>
                    </div>
                }
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação à direita para visualizar os detalhes e confirmar a entrega do voucher." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="vouchers"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1200 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/vouchers/${record.redemption_code}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="vouchers"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
